var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger",on:{"click":_vm.toggleHamburger}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"hamburger__closed"}),_c('div',{staticClass:"hamburger__closed"}),_c('div',{staticClass:"hamburger__closed"}),_c('div',{staticClass:"hamburger__opened left"}),_c('div',{staticClass:"hamburger__opened right"})])
}]

export { render, staticRenderFns }